import {
    IContactLens,
    IContactLensAttributes,
    IContactLensForm,
    IMySavedPrescriptionItem,
    IMySavedPrescriptionsList,
} from '@interfaces/contactsInterfaces';

////////// MY SAVED PRESCRIPTIONS //////////

/** The functions below returns the most recent mapped saved prescriptions */

export const mapSavedPrescriptionsList = (data: any): IMySavedPrescriptionsList => {
    return data.map(element => {
        return {
            ...mapSavedPrescription(element),
        };
    });
};

export const mapSavedPrescription = (data: any): IMySavedPrescriptionItem => {
    return {
        prescriptionName: data.prescriptionName,
        prescriptionId: data.prescriptionId,
        prescriptionType: data.prescriptionType,
        hasRelatedOrderPrescriptions: data.hasRelatedOrderPrescriptions,
        firstName: data.firstName,
        lastName: data.lastName,
        productCategory: data.productCategory,
        prescriptionValue: {
            rightSphere: data.rightSphere,
            leftSphere: data.leftSphere,
            leftCyl: data.leftCyl,
            rightCyl: data.rightCyl,
            rightAxis: data.rightAxis,
            leftAxis: data.leftAxis,
            rightAdd: data.rightAdd,
            leftAdd: data.leftAdd,
            pupillaryDistance: data.pupillaryDistance,
            pdRight: data.rpDistance,
            pdLeft: data.lpDistance,
        },
        prism: {
            prismEnable: data.prismEnable === 'true',
            odVPrism: data.odVPrism,
            osVPrism: data.osVPrism,
            odHPrism: data.odHPrism,
            osHPrism: data.osHPrism,
            odVPrismBaseDir: data.odVPrismBaseDir,
            osVPrismBaseDir: data.osVPrismBaseDir,
            odHPrismBaseDir: data.odHPrismBaseDir,
            osHPrismBaseDir: data.osHPrismBaseDir,
        },
        lastUpdate: data.lastUpdate,
        lastCreate: data.lastCreate,
        leftCatentryId: +data.leftCatentryId,
        rightCatentryId: +data.rightCatentryId,
        leftCatentryParentId: +data.leftCatentryParentId,
        rightCatentryParentId: +data.rightCatentryParentId,
        doctor: {
            name: data.doctor,
            clinic: data.clinic,
            phone: data.doctorFax,
            address: data.doctorAddress,
        },
        submissionMethod: data.prescriptionOriginMode,
        fileName: data.fileName,
        isPrescriptionRetail: data.prescriptionOrigin.toLocaleUpperCase().includes('RETAIL'),
        isPublishedCLLeft: data.isPublishedCLLeft,
        buyableCLLeft: data.buyableCLLeft,
        buyableCLRight: data.buyableCLRight,
        isPublishedCLRight: data.isPublishedCLRight,
    };
};

export const mapToAttributes = (attributes): IContactLensAttributes => {
    /* OLD 
    return {
        power: attributes?.PRD_POWER,
        baseCurve: attributes?.PRF_BASECURVE,
        cylinder: attributes?.PRD_CYLINDER,
        axis: attributes?.PRD_AXIS,
        diameter: attributes?.PRF_DIAMETER,
        add: attributes?.PRD_ADDITION_TXT,
        color: attributes?.PRD_COLOR,
    };*/
    /* NEW: TO PIM */
    return {
        power: attributes?.CL_SPHERE_POWER,
        baseCurve: attributes?.CL_BASE_CURVE,
        cylinder: attributes?.CL_CYLINDER,
        axis: attributes?.CL_AXIS,
        diameter: attributes?.CL_DIAMETER,
        add: attributes?.CL_ADDITION,
        color: attributes?.CL_COLOR,
        dominance: attributes?.CL_DOMINANCE.map(val => {
            return val === 'False' ? 'N' : val === 'True' ? 'D' : '';
        }),
    };
};

export const mapClData = (response): IContactLens => {
    const parentId = +response?.catalogEntry?.catalogEntryIdentifier?.parentProductId;

    return {
        productId: +response?.catalogEntry?.catalogEntryIdentifier.uniqueId,
        name: response?.catalogEntry?.description[0].name,
        model: response?.catalogEntry?.description[0].model,
        brand: response?.catalogEntry?.description[0].brand,
        thumbnail: response?.catalogEntry?.description[0].thumbnail.replace(
            '?imwidth=',
            '?imwidth=80'
        ),
        attributes: mapToAttributes(response?.attributes || response?.catalogEntry?.attributes),
        ...(!!parentId && { parentId: parentId }),
    };
};

export const getInitialValue = (values: any[]) => {
    return values?.length === 1 ? values[0] : '';
};

// remove unused fields and values before submitting the form
export const cleanContactLensForm = (data: IContactLensForm): IContactLensForm => {
    let payload = { ...data } as IContactLensForm;

    // Funzione per rimuovere il segno + dai valori positivi
    const removePlusSign = (value: string): string => {
        return value.startsWith('+') ? value.slice(1) : value;
    };

    // Rimuovi il segno + dai valori positivi in tutti i campi stringa
    /*Object.keys(payload).forEach(key => {
        if (typeof payload[key] === 'string') {
            payload[key] = removePlusSign(payload[key]);
        }
    });*/

    // remove left eye data if not selected
    if (payload.samePrescription) {
        payload.rxLeftAdd = payload.rxRightAdd;
        payload.rxLeftAxis = payload.rxRightAxis;
        payload.rxLeftBc = payload.rxRightBc;
        payload.rxLeftCyl = payload.rxRightCyl;
        payload.rxLeftColor = payload.rxRightColor;
        payload.rxLeftDia = payload.rxRightDia;
        payload.rxLeftPower = payload.rxRightPower;
        payload.rxLeftCyl = payload.rxRightCyl;
        payload.rxLeftDominance = payload.rxRightDominance;
    } else {
        if (!payload.rxLeftEye) {
            const entries = Object.entries(payload).filter(
                ([k, _]): boolean => !k.toLowerCase().includes('left')
            );
            payload = Object.fromEntries(entries) as unknown as IContactLensForm;
            payload.leftQuantity = '0';
        }

        // remove right eye data if not selected
        if (!payload.rxRightEye) {
            const entries = Object.entries(payload).filter(
                ([k, _]) => !k.toLowerCase().includes('right')
            );
            payload = Object.fromEntries(entries) as unknown as IContactLensForm;
            payload.rightQuantity = '0';
        }
    }

    return payload;
};
